<template>
  <div style="padding-top:-2px;margin-top:-2px;">
    <v-label>
      <b>{{ label }} </b>
    </v-label>


    <div>
      <div v-if="mask.length == 0">
        <v-text-field
          ref="text"
          :uppercase="uppercase"
          :append-icon="searchIcon ? 'mdi-magnify' : ''"
          :readonly="readonly"
          :disabled="disabled"
          :prepend-inner-icon="prependInnerIcon"
          :placeholder="placeholderText"
          :dark="dark"
          :autofocus="autofocus"
          :maxlength="maxlength"
          :color="color"
          :type="typeText"
          :clearable="clearable"
          @click="click($event)"
          @click:clear="$emit('close')"
          @click:append="$emit('click:append')"
          @input="input($event)"
          @keyup.enter="enter($event)"
          @keydown.space="space($event)"
          @keypress="validation($event)"
          @blur="blur($event)"
          hide-details="auto"
          :outlined="outlined"
          dense
          @paste="paste($event)"
          aria-autocomplete="off"
          autocomplete="off"
          :value="valueText"
          v-model="valueModel"
          @focus="$emit('focus', $event)"
          :error="hasError"
          :error-messages="errorMessage"
          :rules="computedRules"
          :min="min"
          :max="max"
          :counter="showCounter ? maxlength :null"
          :suffix = "suffix || null"
        >
          <!--  -->
          <template v-slot:prepend> <slot name="prepend"> </slot></template>
          <template v-slot:prepend-inner>
            <slot name="prepend-inner"> </slot
          ></template>
          <template v-slot:append> <slot name="append"> </slot></template>
          <template v-slot:append-outer>
            <div v-if="!decimal"><slot name="append-outer"> </slot></div>
            <div v-else>
              <!--  <v-edit-dialog   class="mb-0 pb-0"  large save-text="" cancel-text="" >
                          <v-btn icon x-small color=""><i class="fas fa-calculator"></i></v-btn>
                          <template v-slot:input >
                            <div class="mt-4 title mb-">Calculadora</div>
                          <s-calculator :data=value @getResult='getResult($event)'></s-calculator>
                          </template>               
                        </v-edit-dialog>-->
            </div>
          </template>
        </v-text-field>
      </div>
      <div v-else>
        <v-text-field
          ref="text"
          :readonly="readonly"
          :outlined="outlined"
          :disabled="disabled"
          :placeholder="placeholderText"
          :dark="dark"
          :autofocus="autofocus"
          :maxlength="maxlength"
          :color="color"
          :type="typeText"
          :clearable="clearable"
          @click:clear="$emit('close')"
          @click:append="$emit('click:append')"
          @click="click($event)"
          @input="input($event)"
          @keyup.enter="enter($event)"
          @keydown.space="space($event)"
          @keypress="validation($event)"
          @blur="blur($event)"
          hide-details="auto"
          dense
          @paste="paste($event)"
          aria-autocomplete="off"
          autocomplete="off"
          :value="valueText"
          v-model="valueModel"
          v-mask="mask"
          @focus="$emit('focus', $event)"
          :error="hasError"
          :error-messages="errorMessage"
          :rules="computedRules"
          :min="min"
          :max="max"
          :counter="showCounter ? maxlength :null"
          :suffix = "suffix || null"
        >
          <!--  -->
          <template v-slot:prepend> <slot name="prepend"> </slot></template>
          <template v-slot:prepend-inner>
            <slot name="prepend-inner"> </slot
          ></template>
          <template v-slot:append> <slot name="append"> </slot></template>
          <template v-slot:append-outer>
            <slot name="append-outer"> </slot
          ></template>
        </v-text-field>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    value: "",
    label: { type: String, default: "" },
    maxlength: { type: [Number, String], default: 256 },
    type: { type: String, default: "text" },
    searchIcon: { type: Boolean, default: false },
    dark: { type: Boolean, default: false },
    autofocus: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    outlined: { type: Boolean, default: true },
    number: { type: Boolean, default: false },
    decimal: { type: Boolean, default: false },
    date: { type: Boolean, default: false },
    time: { type: Boolean, default: false },
    datetime: { type: Boolean, default: false },
    clearable: { type: Boolean, default: false },
    search: { type: Boolean, default: false },
    placeholder: { type: String, default: "" },
    mask: { type: String, default: "" },
    min: {type: Number, default: null},
    max: {type: Number, default: null},
    uppercase: { type: Boolean, default: false },
    rules: { type: Array, default: () => [] }, // Permitir reglas externas
    showCounter : {type: Boolean, default:false},
    suffix: { type: String, default: "" },
    maxDecimal: { type: Number, default: -1 },
    valueDefault: { type: [String, Number], default: "" },
    prependInnerIcon: { type: String, default: "" },
    trimSpaces: { type: Boolean, default: false },
  },
  data() {
    return {//valueModel: "", color: "primary", };
      valueModel: this.value, // Modelo de datos
      touched: false, // Estado para rastrear interacción del usuario
      hasError: false,
      errorMessage: "",
      color: "primary",
    }
  },
  computed: {
    placeholderText() {
      let placeholder = this.placeholder;
      if (this.placeholder == "") {
        if (this.decimal) placeholder = this.maxDecimal != -1 ? `0.${"0".repeat(this.maxDecimal)}` : "0.00";
      }
      return placeholder;
    },
    typeText() {
      let type = this.type;

      if (this.type.length > 0 && (this.date || this.time || this.datetime))
        type = "tel";
      if (this.number) type = "number";
      return type;
    },
    valueText() {
      this.valueModel = this.value;
      return this.value;
    },
    computedRules() {
      let currentRules = [...(this.rules || [])];
      if (this.hasError && this.errorMessage) {
        currentRules.push(() => this.errorMessage);
      }
      return currentRules;
    }
  },

  created() {
    
    this.debouncedGetAnswer = _.debounce(this.getAnswer, 220);
    
    const esVacio = v => v === undefined || v === null || v === '';

    if (esVacio(this.value) && !esVacio(this.valueDefault)) {
      this.valueModel = this.valueDefault;
      this.$emit("input", this.valueModel);
    } else {
      this.valueModel = this.value;
    }

    if (this.decimal && esVacio(this.valueModel)) {
      this.valueModel = 0;
      this.$emit("input", this.valueModel);
    }
  },
  methods: {
    setColor(color) {
      this.color = color ? color : "primary";
    },
    error(msg) {
      if (msg) {
        this.errorMessage = msg;
        this.hasError = true;
      }
      this.setColor("error");
      this.focus();
    },
    getResult(result) {
      this.valueModel = result;
    },
    click() {
      this.$emit("click");
    },
    blur(event) {
      this.touched = true; // Marca el campo como "interactuado"
      
      if (this.trimSpaces && typeof this.valueModel === 'string') {
        const trimmedValue = this.valueModel.trim();
        if (trimmedValue !== this.valueModel) {
          this.valueModel = trimmedValue;
          this.$emit("input", trimmedValue);
        }
      }

      this.$emit("blur", event);
    },
    focus() {
      this.$refs.text.focus();
    },
    validation(evt) {
      evt = evt || window.event;
      const charCode = evt.which || evt.keyCode;
      const charTyped = String.fromCharCode(charCode);
      const currentValue = (this.value || "").toString();

      // Validación de mínimo
      if (this.min == 0) {
        this.localRules = [
          v => v === null || v === undefined || v === ''
            ? true
            : (v > this.min || `El número debe ser mayor o igual a ${this.min}`)
        ];
      }

      // Validar maxlength (número de caracteres total)
      if (this.maxlength && currentValue.length >= parseInt(this.maxlength)) {
        evt.preventDefault();
        return false;
      }

      // Validar límite máximo
      if (!isNaN(evt.key)) {
        const nextValue = currentValue + evt.key;
        const numericValue = parseFloat(nextValue);
        if (this.max !== undefined && numericValue > parseFloat(this.max)) {
          evt.preventDefault();
          return false;
        }
      }

      // Validación para tipo decimal
      if (this.decimal || this.type == "decimal") {
        // Permitir teclas especiales como backspace, etc.
        if (charCode <= 31) return true;

        if (!charTyped.match(/[0-9.]/)) {
          evt.preventDefault();
          return false;
        }

        if (charTyped === "." && currentValue.includes(".")) {
          evt.preventDefault();
          return false;
        }

        // Validar cantidad de decimales
        if (this.maxDecimal != -1 && currentValue.includes(".")) {
          const decimalPart = currentValue.split(".")[1];
          const cursorPos = evt.target.selectionStart;
          const dotIndex = currentValue.indexOf(".");

          if (cursorPos > dotIndex && decimalPart && decimalPart.length >= this.maxDecimal) {
            if (charTyped.match(/[0-9]/)) {
              evt.preventDefault();
              return false;
            }
          }
        }

        return true;
      }

      // Validación para número entero
      if (this.number || this.type == "number") {
        // Permitir solo dígitos
        if (!charTyped.match(/[0-9]/)) {
          evt.preventDefault();
          return false;
        }
        return true;
      }

      this.$emit("keypress");
    },
    trimDecimals(value) {
      if ((this.decimal || this.type == "decimal") && this.maxDecimal != -1 && value) {
        const parts = value.toString().split('.');
        if (parts.length > 1 && parts[1].length > this.maxDecimal) {
          parts[1] = parts[1].substring(0, this.maxDecimal);
          return parts.join('.');
        }
      }
      return value;
    },
    paste(event) {
      const raw = (event.clipboardData || window.clipboardData).getData('text');
      const target = event.target;

      const isDecimal = (this.decimal || this.type == "decimal");
      const isNumber = (this.number || this.type == "number");

      // Para campos numéricos: validar/sanitizar el contenido pegado (evitar letras)
      if (isDecimal || isNumber) {
        // Normalización básica: quitar espacios y permitir coma como separador decimal
        const normalized = (raw || "").toString().trim().replace(/\s+/g, "").replace(/,/g, ".");
        const allowNegative = this.min !== null && this.min !== undefined && this.min < 0;

        // Regex de validación: solo números (y punto para decimales)
        const decimalRegex = allowNegative
          ? /^-?\d*(?:\.\d*)?$/
          : /^\d*(?:\.\d*)?$/;
        const integerRegex = allowNegative
          ? /^-?\d*$/
          : /^\d*$/;

        const isValid = isDecimal ? decimalRegex.test(normalized) : integerRegex.test(normalized);

        // Si contiene caracteres no permitidos (letras/símbolos), bloquear pegado
        if (!isValid) {
          event.preventDefault();
          this.$emit("paste", event);
          return;
        }

        let newValue = normalized;

        // Recortar decimales si aplica
        if (isDecimal && this.maxDecimal != -1 && newValue.includes(".")) {
          const parts = newValue.split('.');
          parts[1] = (parts[1] || "").substring(0, this.maxDecimal);
          newValue = parts.join('.');
        }

        // Insertar manualmente para controlar el resultado final
        event.preventDefault();
        const currentValue = (target.value || "").toString();
        const selectionStart = target.selectionStart ?? currentValue.length;
        const selectionEnd = target.selectionEnd ?? currentValue.length;
        const beforeText = currentValue.substring(0, selectionStart);
        const afterText = currentValue.substring(selectionEnd);
        let merged = beforeText + newValue + afterText;

        // Respetar maxlength (si existe)
        if (this.maxlength && merged.length > parseInt(this.maxlength)) {
          merged = merged.substring(0, parseInt(this.maxlength));
        }

        // Aplicar trim de decimales por seguridad (coherencia con input())
        merged = this.trimDecimals(merged);

        this.valueModel = merged;
        this.$emit("input", this.valueModel);

        const nextPos = Math.min(beforeText.length + newValue.length, (target.value || "").length);
        setTimeout(() => {
          try {
            target.setSelectionRange(nextPos, nextPos);
          } catch (e) {
            // Algunos inputs/tipos pueden no soportar setSelectionRange
          }
        }, 0);

        this.$emit("paste", event);
        return;
      }

      // Si no es numérico, emitir el evento normalmente
      this.$emit("paste", event);
    },
    validate() {
      this.hasError = false;
      this.errorMessage = "";

      for (const rule of this.rules) {
        const result = rule(this.valueModel);
        if (result !== true) {
          this.hasError = true;
          this.errorMessage = result;
          break;
        }
      }
      return !this.hasError; // Devuelve `true` si el campo es válido
    },
    input(val) {
      val = this.trimDecimals(val);
      
      if (!this.search) {
        if (this.uppercase) {
          val = val.toUpperCase();
        }
        this.$emit("input", val);
      } else {
        this.debouncedGetAnswer();
      }
      
      this.hasError = false;
      this.errorMessage = "";
      if (this.touched) this.validate();
    },

    enter() {
      this.$emit("keyupEnter", this.valueModel);
    },
    getAnswer() {
      this.$emit("input", this.valueModel);
    },

    space(event){
      // event.preventDefault();
      this.$emit("keydownSpace", this.valueModel);
    }
  },
  watch: {
    value(newVal) {
      this.color = "primary";
      const trimmedValue = this.trimDecimals(newVal);
      
      // Solo actualizar si hubo cambio
      if (trimmedValue !== newVal) {
        this.valueModel = trimmedValue;
        this.$nextTick(() => {
          this.$emit("input", trimmedValue);
        });
      } else {
        this.valueModel = newVal;
      }
    },
  },
};
</script>
<style></style>
